import { Price } from "./Number";
import { Stat } from "./Stat";

export const BREAK_EVEN_HELP =
  "Effective break-even = (remaining priced cost − cumulative realized trading PnL) ÷ remaining priced tokens. " +
  "Profitable sales lower it; losses raise it. Zero or below means realized gains cover the remaining cost. " +
  "Includes prior closed trades; transfers leave at cost. Excludes unpriced tokens/sales and the separate LP book. " +
  "Uses recorded trade prices, without estimating additional fees. Unavailable for closed or dust positions (< 0.01 tokens).";

export function BreakEven({ value }: { value?: number }) {
  const covered = value !== undefined && Number.isFinite(value) && value <= 0;
  return (
    <span className="inline-flex items-baseline gap-1" title={BREAK_EVEN_HELP}>
      <Price value={value} className={covered ? "text-ok" : undefined} />
      {covered && <span className="text-3xs text-ok">cost covered</span>}
    </span>
  );
}

export function BreakEvenStat({
  value,
  coverage,
  estimated = false,
}: {
  value?: number;
  coverage: number;
  estimated?: boolean;
}) {
  return (
    <Stat
      label={`effective break-even${estimated ? " (est.)" : ""}`}
      value={<BreakEven value={value} />}
      title={BREAK_EVEN_HELP}
      sub={`${Math.round(coverage * 100)}% priced · after realized trading PnL`}
    />
  );
}
